<template>
  <div>
    <div id="content">
      <div class="register">
        <div class="wrapper">
          <div class="inner">
            <div class="main">
              <h1 class="main-title">Privacy Policy</h1>
              <div class="pdpa-statement">
                <div class="item">
                  <div class="heading">1. Our Privacy Statement</div>
                  <div class="info">
                    <p>
                      The protection of your personal data is of great
                      importance to Reeracoen Recruitment Co., Ltd. and
                      Reeracoen Eastern Seaboard Recruitment Co., Ltd (the
                      “Company” or “we”).
                    </p>
                    <p>
                      We process the personal data of job applicant and others
                      to whom those regulations apply (referred to as the “you”
                      throughout this privacy policy) in accordance with the
                      applicable regulation relating to personal data
                      protection, in particular the Personal Data Protection Act
                      B.E. 2562 (“PDPA”). This privacy policy explains how we,
                      as the data controller, process your personal data.
                    </p>
                  </div>
                </div>
                <div class="item">
                  <div class="heading">2. Personal data to be collected</div>
                  <div class="info">
                    <p>
                      We may collect the following personal data for processing
                      to achieve the purposes as herein provided and processed
                      based on the legal basis provided for in the PDPA. In
                      addition, we process your personal data of a sensitive
                      nature, including your religious beliefs and health
                      status, in accordance with special criteria provided in
                      Section 26 of the PDPA.
                    </p>
                    <p>[General Personal Data]</p>
                    <ul>
                      <li>Full Name</li>
                      <li>Photo</li>
                      <li>Address</li>
                      <li>
                        Contact information (Telephone/Mobile number, E-mail
                        Address, Line ID)
                      </li>
                      <li>Birth Date, Age</li>
                      <li>Sex</li>
                      <li>Nationality</li>
                      <li>Family Information</li>
                      <li>Hobby</li>
                      <li>Educational Background</li>
                      <li>Desired Salary</li>
                      <li>
                        Work Experience (Company’s Name, Work period, Position,
                        Tel number, Contact Person's Name and Tel number for
                        reference, Your Evaluation, Salary)
                      </li>
                      <li>Tax ID Number and SSF Number</li>
                      <li>Copy of Resume or CV (Above Data)</li>
                      <li>
                        Copy of ID card (Identification Number, Date of Issue,
                        Date of Expiry, Above Data)
                      </li>
                      <li>
                        Copy of Passport (Passport Number, Date of Issue, Date
                        of Expiry date, Above Data)
                      </li>
                      <li>
                        Copy of Work Permit (Work permit Number, Date of Issue,
                        Date of Expiry date, Above Data)
                      </li>
                      <li>
                        Copy of Education Report (Your Grades, Above Data)
                      </li>
                      <li>
                        Copy of Driver's License (License Number, Kind of
                        License, Date of Issue, Date of Expiry date, Above Data)
                      </li>
                      <li>
                        Copy of House Registration (Registration Number,
                        Previous address, Above data)
                      </li>
                      <li>
                        Copy of Language Certificate (Your Grades, Date of
                        Issue, Above Data)
                      </li>
                      <li>
                        Copy of License Certificate (License Number, Kind of
                        License, Date of Issue, Date of Expiry, Above Data)
                      </li>
                    </ul>
                    <p>[Sensitive Personal Data]</p>
                    <ul>
                      <li>Religion [if shown in the ID card]</li>
                    </ul>
                    <p>
                      We may collect Cookie and similar identifiers, Access
                      logs, Referrers, and the IP address of the device you are
                      using to access our website.
                    </p>
                  </div>
                </div>
                <div class="item">
                  <div class="heading">3. Purpose of the processing</div>
                  <div class="info">
                    <p>
                      The Company collect and process your Personal Data for the
                      following purpose:
                    </p>
                    <ul>
                      <li>Matching with the companies</li>
                      <li>Providing the information about job offers</li>
                      <li>Reference Check with your previous company</li>
                      <li>
                        Suggesting the seminar, consultation meetings and other
                        promotion
                      </li>
                      <li>
                        Sending you information and promotional materials about
                        jobs.
                      </li>
                      <li>
                        Informing benefits, promotion, marketing activities, any
                        activity and project invitation of the Company
                      </li>
                      <li>
                        Providing you with search results and job
                        recommendations that are relevant to you.
                      </li>
                      <li>
                        Facilitating communication as part of the job search and
                        application process.
                      </li>
                      <li>Job interview</li>
                      <li>
                        Contacting for registration for our service, introducing
                        matching company, and providing our service
                      </li>
                      <li>Confirming your identity for proving our service</li>
                      <li>
                        Providing information about our services and responding
                        to inquiries
                      </li>
                      <li>
                        Providing job applicant with supports for the
                        acquisition of official qualifications necessary for
                        working in the working region
                      </li>
                      <li>
                        Managing your information for providing our service
                      </li>
                      <li>Complying with the agreement</li>
                      <li>Creating your account for providing our service</li>
                      <li>
                        Informing any information or notifications to you about
                        our services that you have with us including other
                        services of the Company
                      </li>
                      <li>
                        Confirming your identity for providing our service
                      </li>
                      <li>Providing our services and related services</li>
                      <li>
                        Handling of violations of our terms and conditions,
                        policies, etc. (hereinafter referred to as "Terms and
                        Conditions") regarding our services
                      </li>
                      <li>
                        Prevent fraud, spam, and other potentially fraudulent or
                        illegal activities.
                      </li>
                      <li>
                        Improving and optimizing our services and security for
                        our users and employers by sharing data with our
                        affiliate companies
                      </li>
                      <li>Notifying you of changes to Terms and Conditions</li>
                      <li>
                        For other tasks and responses incidental to the above
                        purposes of use
                      </li>
                      <li>
                        Managing your information for providing our service
                      </li>
                      <li>
                        For acquisitions, divestitures, and other corporate
                        reorganizations. We may disclose personal data to third
                        parties to the extent necessary for these purposes
                      </li>
                      <li>
                        Complying with laws and regulation and order of the
                        governmental authorities
                      </li>
                      <li>
                        Introducing the companies that might be a good match for
                        you, improving the convenience of our website visitors,
                        to research the number of users and traffic on our
                        website, and to improve our services
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="item">
                  <div class="heading">4. Legal basis for the processing</div>
                  <div class="info">
                    <p>4.1 The legal basis for the processing is as follows:</p>
                    <ul>
                      <li>
                        When the processing is necessary for the performance of
                        contractual obligations to you based on Section 24(3) of
                        PDPA.
                      </li>
                      <li>
                        When processing is required for the pursuit of
                        legitimate interests under Section 24 (5) of PDPA.
                      </li>
                      <li>
                        When processing is required for compliance with our
                        legal obligations in accordance with Section 24 (6) of
                        PDPA.
                      </li>
                      <li>
                        When your express consent is obtained in advance based
                        on Section 19 and Section 26 of PDPA.
                      </li>
                    </ul>
                    <p>
                      4.2 You have the right to withdraw your consent at any
                      time by the method separately designated by us. However,
                      your withdrawal of consent will not affect the legality of
                      processing conducted based on your consent before its
                      withdrawal and we may not provide our service or fulfill
                      the contract which need your personal data.
                    </p>
                    <p>
                      We will notify you separately, if the provision of
                      personal data is a statutory or contractual requirement,
                      or a requirement necessary to enter into a contract, as
                      well as the possible consequences of failure to provide
                      such data.
                    </p>
                  </div>
                </div>
                <div class="item">
                  <div class="heading">5. Sources of Personal Data</div>
                  <div class="info">
                    <p>
                      We obtain your personal data directly from you or
                      indirectly through third parties such as those stated
                      below.
                    </p>
                    <ul>
                      <li>Our Group Companies</li>
                      <li>Recruit Portal Site</li>
                      <li>Contracted partner company and agency</li>
                      <li>Referral Person</li>
                    </ul>
                  </div>
                </div>
                <div class="item">
                  <div class="heading">
                    6. Retention Period for Personal Data
                  </div>
                  <div class="info">
                    <p>
                      We will retain your personal data for as long as necessary
                      to fulfill the aforementioned purposes for obtaining and
                      processing your personal data. Specific retention periods
                      are decided based on the following considerations, the
                      purpose for obtaining and processing the personal data;
                      the nature of the personal data; and the necessity of
                      retaining the personal data for legal or business reasons.
                    </p>
                    <p>
                      When the retention period has ended or the retention of
                      such data is no longer necessary (whichever is
                      applicable), we will destroy or erase such data from our
                      system.
                    </p>
                  </div>
                </div>
                <div class="item">
                  <div class="heading">
                    7. Sharing and Disclosure of Personal Data
                  </div>
                  <div class="info">
                    <p>
                      7.1 We share and disclose your personal data to the
                      following third parties in accordance with the PDPA for
                      the purposes stated in this privacy policy. The Company
                      will inform you to acknowledge and request for consent as
                      necessary and required by the PDPA.
                    </p>
                    <ul>
                      <li>The Client companies who seeking employee</li>
                      <li>Recruit Portal Site</li>
                      <li>Our group companies</li>
                      <li>Career Advisor</li>
                      <li>
                        Government and Regulatory Authorities or any
                        Organizations which the Company is under an obligation
                        to make disclosures under the requirements of any law
                        and regulations.
                      </li>
                    </ul>
                    <p>
                      7.2 As a result of the aforementioned sharing and
                      disclosure, in some cases your personal data will be
                      transferred to the following third countries outside
                      Thailand where our group companies or above third party
                      are located. Please note that these countries may not have
                      the inadequate Personal Data protection standards by
                      Personal Data Protection Committee.
                    </p>
                    <ul>
                      <li>Japan</li>
                      <li>Singapore</li>
                      <li>Malaysia</li>
                      <li>Taiwan</li>
                      <li>Philippines</li>
                      <li>Vietnam</li>
                      <li>Indonesia</li>
                    </ul>
                    <p>
                      In such a case, we will implement appropriate safeguards
                      by executing with the transferee the standard data
                      protection causes including Binding Corporate Rules or
                      Data Processing Agreement (if any or whichever is
                      appropriate) according to the PDPA, unless the data
                      transferred country has appropriate data protection
                      standard as prescribed by the Personal Data Protection
                      Committee or the case of exceptions stated in section 28
                      Para.1, such as we obtain your consent or necessary for
                      the performance of a contract to which you are a party. If
                      you wish to receive a copy of documentation related to
                      these safeguards, please inquire using the contact details
                      at the end of this privacy policy.
                    </p>
                  </div>
                </div>
                <div class="item">
                  <div class="heading">8. Your Rights</div>
                  <div class="info">
                    <p>
                      You have the following rights regarding personal data
                      obtained and processed by us.
                    </p>
                    <ul>
                      <li>
                        Obtaining information regarding processing of data: You
                        have the right to obtain from us all the requisite
                        information regarding our data processing activities
                        that concern you.
                      </li>
                      <li>
                        Access to personal data: You have the right to obtain
                        from us confirmation as to whether personal data
                        concerning you are being processed, and, if so, then
                        access to the personal data and certain related
                        information.
                      </li>
                      <li>
                        Rectification or erasure of personal data: You have the
                        right to have us rectify inaccurate personal data
                        concerning you without undue delay and the right to have
                        us complete any incomplete personal data. Also, if
                        certain conditions are satisfied, you will have the
                        right to have us delete personal data concerning you
                        without undue delay.
                      </li>
                      <li>
                        Restriction on processing of personal data: If certain
                        conditions are satisfied, you will have the right to
                        have us restrict processing of personal data concerning
                        you.
                      </li>
                      <li>
                        Objection to processing of personal data: If certain
                        conditions are satisfied, you will have the right to
                        object to processing of personal data concerning you
                      </li>
                      <li>
                        Data portability of personal data: If certain conditions
                        are satisfied, you will have the right to receive
                        personal data concerning you in a structured, commonly
                        used, and machine-readable format and the right to
                        transfer those data to another controller without
                        hindrance from us.
                      </li>
                      <li>
                        Right to rectification: If you believe that the personal
                        data we collect or process is wrong, you have the right
                        to ask for such data to be rectified.
                      </li>
                    </ul>
                    <p>
                      If you intend to exercise any of the aforementioned
                      rights, please inquire using the contact details at the
                      end of this privacy policy.
                    </p>
                  </div>
                </div>
                <div class="item">
                  <div class="heading">9. Amendment to this Privacy Policy</div>
                  <div class="info">
                    <p>
                      We amend this privacy policy from time to time. We will
                      contact you through this website and by e-mail if
                      necessary when we make any substantive or material
                      amendments.
                    </p>
                  </div>
                </div>
                <div class="item">
                  <div class="heading">10. Contact Details</div>
                  <div class="info">
                    <p>
                      For questions or inquiries regarding this privacy policy,
                      please contact the Company or Data Protection Officer set
                      out below.
                    </p>
                  </div>
                </div>
                <p class="heading">Company (Data Controller)</p>
                <div class="company-address">
                  <ul>
                    <li class="heading">Reeracoen Recruitment Co., Ltd.</li>
                    <li>
                      Address: 801 8th Floor, Mercury Tower, 540 Ploenchit Road,
                      Lumphini, Pathum Wan, Bangkok 10330
                    </li>
                    <li>
                      Email:
                      <a href="mailto:info@reeracoen.co.th" target="_blank"
                        >info@reeracoen.co.th</a
                      >
                    </li>
                    <li>
                      Phone:
                      <a href="tel:+66022539800">(+66) 02-253-9800</a>
                    </li>
                  </ul>
                </div>
                <div class="company-address">
                  <ul>
                    <li class="heading">
                      Reeracoen Eastern Seaboard Recruitment Co., Ltd
                    </li>
                    <li>
                      Address: 4/222 Harbormall Bldg. Unit 10C04-05, 10th Floor,
                      Moo 10, Sukhumvit Road Thungsukhla, Sriracha, Chonburi
                      20230 Thailand
                    </li>
                    <li>
                      Email:
                      <a href="mailto:info@reeracoen.co.th" target="_blank"
                        >info@reeracoen.co.th</a
                      >
                    </li>
                    <li>
                      Phone:
                      <a href="tel:+66038111256">(+66) 03-811-1256</a>
                    </li>
                  </ul>
                </div>
                <p>
                  We have also appointed a Data Protection Officer. The Data
                  Protection Officer's contact details are as follows:
                </p>
                <div class="company-address">
                  <ul>
                    <li class="heading">The Data Protection Officer</li>
                    <li>
                      Address: 801 8th Floor, Mercury Tower, 540 Ploenchit Road,
                      Lumphini, Pathum Wan, Bangkok 10330
                    </li>
                    <li>
                      Email:
                      <a href="mailto:info@reeracoen.co.th" target="_blank"
                        >info@reeracoen.co.th</a
                      >
                    </li>
                    <li>
                      Phone:
                      <a href="tel:+66022539800">(+66) 02-253-9800</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="button-row">
                <button class="btn btn-outline" type="submit">Decline</button>
                <button class="btn btn-blue" type="submit">
                  I accept the privacy policy
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/Footer";
export default {
  name: "CddRegisterPDPA",
  components: {
    Footer,
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
@import "~@/assets/stylesheets/register";

.pdpa-statement {
  margin-top: 4rem;
  color: $black;
  font-size: 1em;
  p {
    line-height: 1.5rem;
    margin-bottom: 1rem;
  }
  .heading {
    font-weight: 500;
    font-size: 1.05em;
  }
  .item {
    display: flex;
    margin-bottom: 1.5rem;
    .heading {
      width: 30%;
    }
    .info {
      width: 70%;
    }
    ul {
      list-style-type: disc;
      list-style-position: inside;
      margin-bottom: 1rem;
      li {
        line-height: 1.5rem;
        margin-bottom: 0.5rem;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .company-address {
    margin-bottom: 1rem;
    .heading {
      font-weight: 500;
      font-size: unset;
    }
    ul {
      li {
        line-height: 1.5rem;
        margin-bottom: 5px;
      }
    }
    a {
      color: #3742fa;
      display: inline;
    }
  }
}
.button-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
  button {
    margin: 0 0.5rem;
  }
}

@media only screen and (max-width: 991px) {
  .pdpa-statement {
    margin-top: 2rem;
    .item {
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
      .heading {
        width: 100%;
        margin-bottom: 1rem;
      }
      .info {
        width: 100%;
      }
      ul {
        li {
          line-height: 1.5rem;
          margin-bottom: 0.5rem;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .company-address {
      ul {
        li {
          line-height: 1.5rem;
        }
      }
    }
  }
  .button-row {
    flex-direction: column;
    button {
      margin: 0.5rem 0;
    }
  }
}
</style>
